import {customDocumentEvent} from "../../../webpack/modules/events";
import {previewOption} from "../../../webpack/modules-optimized/product";

customDocumentEvent('productColorChanged', function(event) {
    let option = event.detail.option;
    let previewElement = event.detail.previewElement;
    let colorSelected = event.detail.colorSelected;
    let orientationElement = event.detail.orientationElement;
    let defaultOrientationElement = event.detail.defaultOrientationElement;
    let glassReversedElement = event.detail.glassReversedElement;
    let hardMaterial = event.detail.hardMaterial;

    /*console.log(colorSelected);
    console.log(orientationElement);
    console.log(defaultOrientationElement);*/

    previewOption(option, previewElement);
    hiddenOrientation(hardMaterial, orientationElement, defaultOrientationElement);
    hiddenGlassReversed(hardMaterial, glassReversedElement);
});

function hiddenOrientation(hardMaterial, orientation, defaultElement)
{
    if (!orientation || !defaultElement) return;

    if (hardMaterial === "true") {
    // if (selectedColor == 104 || selectedColor == 106 || selectedColor == 107 || selectedColor == 108 || selectedColor == 109 || selectedColor == 111 || selectedColor == 112) {
        defaultElement.checked = true;
        if (!orientation.classList.contains('d-none')) orientation.classList.add('d-none');
    } else {
        orientation.classList.remove('d-none');
    }
}

function hiddenGlassReversed(hardMaterial, glassReversed)
{
    if (!glassReversed) return;

    if (hardMaterial === "true") {
        let inputElement = glassReversed.querySelector('input[name="glass-reversed"]');
        if (inputElement) inputElement.checked = false;
        if (!glassReversed.classList.contains('d-none')) glassReversed.classList.add('d-none');
    } else {
        glassReversed.classList.remove('d-none');
    }
}